var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.48 10.833H4.166a.806.806 0 0 1-.594-.24.806.806 0 0 1-.24-.593c0-.236.08-.434.24-.594.16-.16.358-.24.594-.24h9.312L9.396 5.084a.763.763 0 0 1-.24-.583.839.839 0 0 1 .26-.583.879.879 0 0 1 .584-.24.763.763 0 0 1 .584.24l5.5 5.5a.731.731 0 0 1 .177.27.923.923 0 0 1 .052.313.923.923 0 0 1-.052.313.731.731 0 0 1-.177.27l-5.5 5.5a.777.777 0 0 1-.573.23.849.849 0 0 1-.594-.23.811.811 0 0 1-.25-.593c0-.23.083-.427.25-.594l4.062-4.063Z",
    fill: "#58B847"
  }))));
};
export default SvgArrow;